import { FaArrowRight } from 'react-icons/fa';
import { openZohoChat } from '../utils/openZohoChat';
import { HERO_CARDS } from '../data/content';
import './Hero.css';

export default function Hero() {
  return (
    <section className="dh-hero" id="home">
      <div className="dh-hero__glow" aria-hidden />
      <div className="dh-container dh-hero__grid">
        <div className="dh-hero__copy">
          <h1>Get Dragon Speaking Support</h1>
          <p>
            Fast, friendly help for Dragon NaturallySpeaking — installation, microphone setup,
            activation, accuracy tuning, and error-code recovery from certified support specialists.
          </p>
          <div className="dh-hero__actions">
            <button type="button" className="dh-btn dh-btn--light" onClick={openZohoChat}>
              Get Quotes
            </button>
            <a href="#support" className="dh-link-light">
              Learn More <FaArrowRight aria-hidden />
            </a>
          </div>
        </div>
        <div className="dh-hero__media">
          <img
            src="/images/agent.jpg"
            alt="Dragon Help support specialist ready to assist"
            width="520"
            height="520"
          />
        </div>
      </div>

      <div className="dh-container dh-hero__cards">
        {HERO_CARDS.map((card) => (
          <a key={card.id} href="#support" className="dh-hero-card">
            {card.label}
          </a>
        ))}
      </div>
    </section>
  );
}
